const config = {};

module.exports = config;
